import { EmploymentType, WorkerEmploymentType } from '@types';

type FormEmploymentFlags = {
  isFreelance: boolean;
  isTempwork: boolean;
  isEmployee: boolean;
};

const isAllowed = (flags: FormEmploymentFlags, employmentType?: WorkerEmploymentType): boolean => {
  if (!employmentType) {
    return true;
  }

  switch (employmentType) {
    case EmploymentType.FREELANCER:
      return flags.isFreelance;
    case EmploymentType.TEMPWORKER:
      return flags.isTempwork;
    case EmploymentType.EMPLOYEE:
      return flags.isEmployee;
    default:
      return true;
  }
};

export const hasEmploymentTypeMismatch = (
  formFlags: FormEmploymentFlags,
  employmentTypes: WorkerEmploymentType[]
): boolean => employmentTypes.some((t) => !isAllowed(formFlags, t));
